export default {
  en: {
    "accounting.label.ThisTransactionIsReversed": "This Transaction is Reversed",
    "accounting.label.FixedAmount": "Fixed Amount",
    "accounting.label.Accounts": "Accounts",
    "accounting.label.chartofaccounts": "Chart Of Accounts",
    "accounting.label.createaccount": "Create Account",
    "accounting.label.account": "Account",
    "accounting.label.glcode": "GL Code",
    "accounting.label.accounttype": "Account Type",
    "accounting.label.disabled": "Disabled",
    "accounting.label.manualentriesallowed": "Manual Entries Allowed",
    "accounting.label.usedas": "Used as",
    "accounting.label.createglaccount": "Create GL Account",
    "accounting.label.parent": "Parent",
    "accounting.label.accountname": "Account Name",
    "accounting.label.accountusage": "Account Usage",
    "accounting.label.tag": "Tag",
    "accounting.label.description": "Description",
    "accounting.label.viewglaccount": "View GL Account",
    "accounting.label.editglaccount": "Edit GL Account",
    "accounting.label.submit": "Submit",
    "accounting.label.update": "Update",
    "accounting.label.cancel": "Cancel",
    "accounting.label.disable": "Disable",
    "accounting.label.enable": "Enable",
    "accounting.label.name": "Name",
    "accounting.label.action": "Actions",
    "accounting.label.editrule": "Edit Accounting Rule",
    "accounting.label.viewrule": "View Accounting Rule",
    "accounting.label.debitaccountdetails": "Debit Account Details",
    "accounting.label.creditaccountdetails": "Credit Account Details",
    "accounting.label.accountingrulename": "Accounting Rule Name",
    "accounting.label.affectedglentries": "Affected GL Entries",
    "accounting.label.createrule": "Create Accounting Rule",
    "accounting.label.accountingrules": "Accounting Rules",
    "accounting.label.debitaccount": "Debit Account",
    "accounting.label.creditaccount": "Credit Account",
    "accounting.label.debittags": "Debit Tags",
    "accounting.label.credittagid": "Credit Tag Id",
    "accounting.label.credittagname": "Credit Tag Name",
    "accounting.label.debittagid": "Debit Tag Id",
    "accounting.label.debittagname": "Debit Tag Name",
    "accounting.label.transactiontype": "Transaction Type",
    "accounting.label.credittags": "Credit Tags",
    "accounting.label.entityname": "Business Entity Name",
    "accounting.label.allowmultipledebitentries":
      "Allow Multiple Debit Entries",
    "accounting.label.allowmultiplecreditentries":
      "Allow Multiple Credit Entries",
    "accounting.label.subledgeraccount": "Subledger Account",
    "accounting.label.closingentries": "Closing Entries",
    "accounting.label.accountclosuredate": "Account Closure Date",
    "accounting.label.comments": "Comments",
    "accounting.label.entity": "Business Entity",
    "accounting.label.closuredate": "Closure Date",
    "accounting.label.closedby": "Closed By",
    "accounting.label.updatedby": "Updated By",
    "accounting.label.updatedon": "Updated On",
    "accounting.label.viewclosure": "View Closure",
    "accounting.label.closurecreationdate": "Closure Creation Date",
    "accounting.label.closingdate": "Closing Date",
    "accounting.label.createclosure": "Create Closure",
    "accounting.label.frequentpostings": "Frequent Postings",
    "accounting.label.debit": "Debit",
    "accounting.label.credit": "Credit",
    "accounting.label.currency": "Currency",
    "accounting.label.showpaymentdetails": "Show Payment Details",
    "accounting.label.paymenttype": "Payment Type",
    "accounting.label.cheque": "Cheque",
    "accounting.label.routingcode": "Routing Code",
    "accounting.label.receipt": "Receipt",
    "accounting.label.bank": "Bank",
    "accounting.label.comment": "Comment",
    "accounting.label.transactiondate": "Transaction Date",
    "accounting.label.referencenumber": "Reference Number",
    "accounting.label.closeaccountcreatedby": "Closure Account Created By",
    "accounting.label.addjournalentries": "Add Journal Entries",
    "accounting.label.amount": "Amount",
    "accounting.label.financialactivitymapping": "Financial Activity Mapping",
    "accounting.label.definenewmapping": "Define New Mapping",
    "accounting.label.addfinancialactivitymapping":
      "Add Financial Activity Mapping",
    "accounting.label.editfinancialactivitymapping":
      "Edit Financial Activity Mapping",
    "accounting.label.viewfinancialactivitymapping":
      "View Financial Activity Mapping",
    "accounting.label.financialactivity": "Financial Activity",
    "accounting.label.office": "Office",
    "accounting.label.filter": "Filter",
    "accounting.label.fromdate": "From Date",
    "accounting.label.todate": "To Date",
    "accounting.label.transactionid": "Transaction Id",
    "accounting.label.search": "Search",
    "accounting.label.entryid": "Entry Id",
    "accounting.label.type": "Type",
    "accounting.label.clearall": "Clear All",
    "accounting.label.createdby": "Created By",
    "accounting.label.dateofopeningbalances": "Date Of Opening Balances",
    "accounting.label.openingbalancescontra": "Opening Balances Contra",
    "accounting.label.openingbalances": "Opening Balances",
    "accounting.label.save": "Save",
    "accounting.label.transactionnumber": "Transaction Number",
    "accounting.label.reverse": "Reverse",
    "accounting.label.viewtransaction": "View Transaction",
    "accounting.label.createdon": "Created On",
    "accounting.label.editclosure": "Edit Closure",
  },

  fr: {
    "accounting.label.ThisTransactionIsReversed": "Cette transaction est annulée",
    "accounting.label.FixedAmount": "Montant fixe",
"accounting.label.Accounts": "Comptes",
    "accounting.label.chartofaccounts": "Plan Comptable",
    "accounting.label.createaccount": "Créer un Compte",
    "accounting.label.account": "Compte",
    "accounting.label.glcode": "Code GL",
    "accounting.label.accounttype": "Type de Compte",
    "accounting.label.disabled": "Désactivé",
    "accounting.label.manualentriesallowed": "Entrées Manuelles Autorisées",
    "accounting.label.usedas": "Utilisé comme",
    "accounting.label.createglaccount": "Créer un Compte GL",
    "accounting.label.parent": "Parent",
    "accounting.label.accountname": "Nom du Compte",
    "accounting.label.accountusage": "Utilisation du Compte",
    "accounting.label.tag": "Étiquette",
    "accounting.label.description": "Description",
    "accounting.label.viewglaccount": "Voir le Compte GL",
    "accounting.label.editglaccount": "Modifier le Compte GL",
    "accounting.label.submit": "Soumettre",
    "accounting.label.update": "Mettre à Jour",
    "accounting.label.cancel": "Annuler",
    "accounting.label.disable": "Désactiver",
    "accounting.label.enable": "Activer",
    "accounting.label.name": "Nom",
    "accounting.label.action": "Action",
    "accounting.label.editrule": "Modifier la règle",
    "accounting.label.viewrule": "Voir la règle",
    "accounting.label.debitaccountdetails": "Détails du compte de débit",
    "accounting.label.creditaccountdetails": "Détails du compte de crédit",
    "accounting.label.accountingrulename": "Nom de la règle comptable",
    "accounting.label.affectedglentries": "Écritures GL affectées",
    "accounting.label.createrule": "Créer une règle",
    "accounting.label.accountingrules": "Règles comptables",
    "accounting.label.debitaccount": "Compte de débit",
    "accounting.label.creditaccount": "Compte de crédit",
    "accounting.label.debittags": "Étiquettes de débit",
    "accounting.label.credittags": "Étiquettes de crédit",
    "accounting.label.entityname": "Nom de l'entité",
    "accounting.label.allowmultipledebitentries":
      "Autoriser plusieurs entrées de débit",
    "accounting.label.allowmultiplecreditentries":
      "Autoriser plusieurs entrées de crédit",
    "accounting.label.subledgeraccount": "Compte de sous-grand livre",
    "accounting.label.closingentries": "Écritures de Clôture",
    "accounting.label.accountclosuredate": "Date de Clôture du Compte",
    "accounting.label.comments": "Commentaires",
    "accounting.label.entity": "Entité",
    "accounting.label.closuredate": "Date de Clôture",
    "accounting.label.closedby": "Fermé Par",
    "accounting.label.updatedby": "Mis à Jour Par",
    "accounting.label.updatedon": "Mis à Jour Le",
    "accounting.label.viewclosure": "Voir Clôture",
    "accounting.label.closurecreationdate": "Date de Création de Clôture",
    "accounting.label.closingdate": "Date de Fermeture",
    "accounting.label.createclosure": "Créer Clôture",
    "accounting.label.closeaccountcreatedby": "Compte de Clôture Créé Par",
    "accounting.label.frequentpostings": "Publications fréquentes",
    "accounting.label.debit": "Débit",
    "accounting.label.credit": "Crédit",
    "accounting.label.currency": "Devise",
    "accounting.label.showpaymentdetails": "Afficher les détails du paiement",
    "accounting.label.paymenttype": "Type de paiement",
    "accounting.label.cheque": "Chèque",
    "accounting.label.routingcode": "Code de routage",
    "accounting.label.receipt": "Reçu",
    "accounting.label.bank": "Banque",
    "accounting.label.comment": "Commentaire",
    "accounting.label.transactiondate": "Date de transaction",
    "accounting.label.referencenumber": "Numéro de référence",
    "accounting.label.addjournalentries": "Ajouter des écritures comptables",
    "accounting.label.amount": "Montant",
    "accounting.label.financialactivitymapping":
      "Cartographie de l'activité financière",
    "accounting.label.definenewmapping": "Définir une nouvelle cartographie",
    "accounting.label.addfinancialactivitymapping":
      "Ajouter une cartographie d'activité financière",
    "accounting.label.editfinancialactivitymapping":
      "Modifier la cartographie d'activité financière",
    "accounting.label.viewfinancialactivitymapping":
      "Afficher la cartographie d'activité financière",
    "accounting.label.financialactivity": "Activité financière",
    "accounting.label.office": "Bureau",
    "accounting.label.filter": "Filtrer",
    "accounting.label.fromdate": "Date de début",
    "accounting.label.todate": "Date de fin",
    "accounting.label.transactionid": "ID de transaction",
    "accounting.label.search": "Rechercher",
    "accounting.label.entryid": "ID d'entrée",
    "accounting.label.type": "Type",
    "accounting.label.clearall": "Tout effacer",
    "accounting.label.createdby": "Créé par",
    "accounting.label.dateofopeningbalances": "Date des Soldes d'Ouverture",
    "accounting.label.openingbalancescontra":
      "Contrepartie des Soldes d'Ouverture",
    "accounting.label.openingbalances": "Soldes d'Ouverture",
    "accounting.label.save": "Enregistrer",
    "accounting.label.viewtransaction": "Voir la transaction",
    "accounting.label.createdon": "Créé le",
    "accounting.label.editclosure": "Modifier la clôture",
  },

  es: {
    "accounting.label.ThisTransactionIsReversed": "Esta transacción ha sido revertida",
    "accounting.label.FixedAmount": "Cantidad fija",
"accounting.label.Accounts": "Cuentas",
    "accounting.label.chartofaccounts": "Plan de Cuentas",
    "accounting.label.createaccount": "Crear Cuenta",
    "accounting.label.account": "Cuenta",
    "accounting.label.glcode": "Código GL",
    "accounting.label.accounttype": "Tipo de Cuenta",
    "accounting.label.disabled": "Deshabilitado",
    "accounting.label.manualentriesallowed": "Entradas Manuales Permitidas",
    "accounting.label.usedas": "Usado como",
    "accounting.label.createglaccount": "Crear Cuenta GL",
    "accounting.label.parent": "Principal",
    "accounting.label.accountname": "Nombre de la Cuenta",
    "accounting.label.accountusage": "Uso de la Cuenta",
    "accounting.label.tag": "Etiqueta",
    "accounting.label.description": "Descripción",
    "accounting.label.viewglaccount": "Ver Cuenta GL",
    "accounting.label.editglaccount": "Editar Cuenta GL",
    "accounting.label.submit": "Enviar",
    "accounting.label.update": "Actualizar",
    "accounting.label.cancel": "Cancelar",
    "accounting.label.disable": "Deshabilitar",
    "accounting.label.enable": "Habilitar",
    "accounting.label.name": "Nombre",
    "accounting.label.action": "Acción",
    "accounting.label.editrule": "Editar regla",
    "accounting.label.viewrule": "Ver regla",
    "accounting.label.debitaccountdetails": "Detalles de la cuenta de débito",
    "accounting.label.creditaccountdetails": "Detalles de la cuenta de crédito",
    "accounting.label.accountingrulename": "Nombre de la regla contable",
    "accounting.label.affectedglentries": "Asientos GL afectados",
    "accounting.label.createrule": "Crear regla",
    "accounting.label.accountingrules": "Reglas contables",
    "accounting.label.debitaccount": "Cuenta de débito",
    "accounting.label.creditaccount": "Cuenta de crédito",
    "accounting.label.debittags": "Etiquetas de débito",
    "accounting.label.credittags": "Etiquetas de crédito",
    "accounting.label.entityname": "Nombre de la entidad",
    "accounting.label.allowmultipledebitentries":
      "Permitir múltiples entradas de débito",
    "accounting.label.allowmultiplecreditentries":
      "Permitir múltiples entradas de crédito",
    "accounting.label.subledgeraccount": "Cuenta de sublibro mayor",
    "accounting.label.closingentries": "Asientos de Cierre",
    "accounting.label.accountclosuredate": "Fecha de Cierre de la Cuenta",
    "accounting.label.comments": "Comentarios",
    "accounting.label.entity": "Entidad",
    "accounting.label.closuredate": "Fecha de Cierre",
    "accounting.label.closedby": "Cerrado Por",
    "accounting.label.updatedby": "Actualizado Por",
    "accounting.label.updatedon": "Actualizado El",
    "accounting.label.viewclosure": "Ver Cierre",
    "accounting.label.closurecreationdate": "Fecha de Creación del Cierre",
    "accounting.label.closingdate": "Fecha de Cierre",
    "accounting.label.createclosure": "Crear Cierre",
    "accounting.label.closeaccountcreatedby": "Cuenta de Cierre Creada Por",
    "accounting.label.frequentpostings": "Publicaciones frecuentes",
    "accounting.label.debit": "Débito",
    "accounting.label.credit": "Crédito",
    "accounting.label.currency": "Moneda",
    "accounting.label.showpaymentdetails": "Mostrar detalles de pago",
    "accounting.label.paymenttype": "Tipo de pago",
    "accounting.label.cheque": "Cheque",
    "accounting.label.routingcode": "Código de ruta",
    "accounting.label.receipt": "Recibo",
    "accounting.label.bank": "Banco",
    "accounting.label.comment": "Comentario",
    "accounting.label.transactiondate": "Fecha de transacción",
    "accounting.label.referencenumber": "Número de referencia",
    "accounting.label.addjournalentries": "Agregar asientos contables",
    "accounting.label.amount": "Cantidad",
    "accounting.label.financialactivitymapping":
      "Mapeo de Actividad Financiera",
    "accounting.label.definenewmapping": "Definir Nuevo Mapeo",
    "accounting.label.addfinancialactivitymapping":
      "Agregar Mapeo de Actividad Financiera",
    "accounting.label.editfinancialactivitymapping":
      "Editar Mapeo de Actividad Financiera",
    "accounting.label.viewfinancialactivitymapping":
      "Ver Mapeo de Actividad Financiera",
    "accounting.label.financialactivity": "Actividad Financiera",
    "accounting.label.office": "Oficina",
    "accounting.label.filter": "Filtrar",
    "accounting.label.fromdate": "Fecha de inicio",
    "accounting.label.todate": "Fecha de fin",
    "accounting.label.transactionid": "ID de transacción",
    "accounting.label.search": "Buscar",
    "accounting.label.entryid": "ID de entrada",
    "accounting.label.type": "Tipo",
    "accounting.label.clearall": "Limpiar todo",
    "accounting.label.createdby": "Creado por",
    "accounting.label.dateofopeningbalances": "Fecha de los Saldos de Apertura",
    "accounting.label.openingbalancescontra":
      "Contrapartida de los Saldos de Apertura",
    "accounting.label.openingbalances": "Saldos de Apertura",
    "accounting.label.save": "Guardar",
    "accounting.label.viewtransaction": "Ver transacción",
    "accounting.label.createdon": "Creado el",
    "accounting.label.editclosure": "Editar cierre",
  },

  pt: {
    "accounting.label.ThisTransactionIsReversed": "Esta transação foi revertida",
    "accounting.label.FixedAmount": "Montante fixo",
"accounting.label.Accounts": "Contas",
    "accounting.label.chartofaccounts": "Plano de Contas",
    "accounting.label.createaccount": "Criar Conta",
    "accounting.label.account": "Conta",
    "accounting.label.glcode": "Código GL",
    "accounting.label.accounttype": "Tipo de Conta",
    "accounting.label.disabled": "Desativado",
    "accounting.label.manualentriesallowed": "Entradas Manuais Permitidas",
    "accounting.label.usedas": "Usado como",
    "accounting.label.createglaccount": "Criar Conta GL",
    "accounting.label.parent": "Pai",
    "accounting.label.accountname": "Nome da Conta",
    "accounting.label.accountusage": "Uso da Conta",
    "accounting.label.tag": "Etiqueta",
    "accounting.label.description": "Descrição",
    "accounting.label.viewglaccount": "Ver Conta GL",
    "accounting.label.editglaccount": "Editar Conta GL",
    "accounting.label.submit": "Enviar",
    "accounting.label.update": "Atualizar",
    "accounting.label.cancel": "Cancelar",
    "accounting.label.disable": "Desativar",
    "accounting.label.enable": "Ativar",
    "accounting.label.name": "Nome",
    "accounting.label.action": "Ação",
    "accounting.label.editrule": "Editar regra",
    "accounting.label.viewrule": "Ver regra",
    "accounting.label.debitaccountdetails": "Detalhes da conta de débito",
    "accounting.label.creditaccountdetails": "Detalhes da conta de crédito",
    "accounting.label.accountingrulename": "Nome da regra contábil",
    "accounting.label.affectedglentries": "Lançamentos GL afetados",
    "accounting.label.createrule": "Criar regra",
    "accounting.label.accountingrules": "Regras contábeis",
    "accounting.label.debitaccount": "Conta de débito",
    "accounting.label.creditaccount": "Conta de crédito",
    "accounting.label.debittags": "Etiquetas de débito",
    "accounting.label.credittags": "Etiquetas de crédito",
    "accounting.label.entityname": "Nome da entidade",
    "accounting.label.allowmultipledebitentries":
      "Permitir múltiplas entradas de débito",
    "accounting.label.allowmultiplecreditentries":
      "Permitir múltiplas entradas de crédito",
    "accounting.label.subledgeraccount": "Conta de subconta",
    "accounting.label.closingentries": "Lançamentos de Fechamento",
    "accounting.label.accountclosuredate": "Data de Fechamento da Conta",
    "accounting.label.comments": "Comentários",
    "accounting.label.entity": "Entidade",
    "accounting.label.closuredate": "Data de Fechamento",
    "accounting.label.closedby": "Fechado Por",
    "accounting.label.updatedby": "Atualizado Por",
    "accounting.label.updatedon": "Atualizado Em",
    "accounting.label.viewclosure": "Ver Fechamento",
    "accounting.label.closurecreationdate": "Data de Criação do Fechamento",
    "accounting.label.closingdate": "Data de Encerramento",
    "accounting.label.createclosure": "Criar Fechamento",
    "accounting.label.closeaccountcreatedby": "Conta de Fechamento Criada Por",
    "accounting.label.frequentpostings": "Lançamentos frequentes",
    "accounting.label.debit": "Débito",
    "accounting.label.credit": "Crédito",
    "accounting.label.currency": "Moeda",
    "accounting.label.showpaymentdetails": "Mostrar detalhes do pagamento",
    "accounting.label.paymenttype": "Tipo de pagamento",
    "accounting.label.cheque": "Cheque",
    "accounting.label.routingcode": "Código de roteamento",
    "accounting.label.receipt": "Recibo",
    "accounting.label.bank": "Banco",
    "accounting.label.comment": "Comentário",
    "accounting.label.transactiondate": "Data da transação",
    "accounting.label.referencenumber": "Número de referência",
    "accounting.label.addjournalentries": "Adicionar lançamentos contábeis",
    "accounting.label.amount": "Valor",
    "accounting.label.financialactivitymapping":
      "Mapeamento de Atividade Financeira",
    "accounting.label.definenewmapping": "Definir Novo Mapeamento",
    "accounting.label.addfinancialactivitymapping":
      "Adicionar Mapeamento de Atividade Financeira",
    "accounting.label.editfinancialactivitymapping":
      "Editar Mapeamento de Atividade Financeira",
    "accounting.label.viewfinancialactivitymapping":
      "Visualizar Mapeamento de Atividade Financeira",
    "accounting.label.financialactivity": "Atividade Financeira",
    "accounting.label.office": "Escritório",
    "accounting.label.filter": "Filtrar",
    "accounting.label.fromdate": "Data de início",
    "accounting.label.todate": "Data de fim",
    "accounting.label.transactionid": "ID da transação",
    "accounting.label.search": "Buscar",
    "accounting.label.entryid": "ID de entrada",
    "accounting.label.type": "Tipo",
    "accounting.label.clearall": "Limpar tudo",
    "accounting.label.createdby": "Criado por",
    "accounting.label.dateofopeningbalances": "Data dos Saldos de Abertura",
    "accounting.label.openingbalancescontra":
      "Contrapartida dos Saldos de Abertura",
    "accounting.label.openingbalances": "Saldos de Abertura",
    "accounting.label.save": "Salvar",
    "accounting.label.viewtransaction": "Ver Transação",
    "accounting.label.createdon": "Criado em",
    "accounting.label.editclosure": "Editar Fechamento",
  },

  zh_CN: {
    "accounting.label.ThisTransactionIsReversed": "此交易已被撤销",
    "accounting.label.FixedAmount": "固定金额",
"accounting.label.Accounts": "账户",
    "accounting.label.chartofaccounts": "科目表",
    "accounting.label.createaccount": "创建账户",
    "accounting.label.account": "账户",
    "accounting.label.glcode": "总分类账户代码",
    "accounting.label.accounttype": "账户类型",
    "accounting.label.disabled": "已禁用",
    "accounting.label.manualentriesallowed": "允许手动输入",
    "accounting.label.usedas": "用作",
    "accounting.label.createglaccount": "创建总分类账户",
    "accounting.label.parent": "上级账户",
    "accounting.label.accountname": "账户名称",
    "accounting.label.accountusage": "账户用途",
    "accounting.label.tag": "标签",
    "accounting.label.description": "描述",
    "accounting.label.viewglaccount": "查看总分类账户",
    "accounting.label.editglaccount": "编辑总分类账户",
    "accounting.label.submit": "提交",
    "accounting.label.update": "更新",
    "accounting.label.cancel": "取消",
    "accounting.label.disable": "禁用",
    "accounting.label.enable": "启用",
    "accounting.label.name": "名称",
    "accounting.label.action": "操作",
    "accounting.label.editrule": "编辑规则",
    "accounting.label.viewrule": "查看规则",
    "accounting.label.debitaccountdetails": "借方账户详情",
    "accounting.label.creditaccountdetails": "贷方账户详情",
    "accounting.label.accountingrulename": "会计规则名称",
    "accounting.label.affectedglentries": "受影响的总账条目",
    "accounting.label.createrule": "创建规则",
    "accounting.label.accountingrules": "会计规则",
    "accounting.label.debitaccount": "借方账户",
    "accounting.label.creditaccount": "贷方账户",
    "accounting.label.debittags": "借方标签",
    "accounting.label.credittags": "贷方标签",
    "accounting.label.entityname": "实体名称",
    "accounting.label.allowmultipledebitentries": "允许多个借方条目",
    "accounting.label.allowmultiplecreditentries": "允许多个贷方条目",
    "accounting.label.subledgeraccount": "子分类账账户",
    "accounting.label.closingentries": "结账分录",
    "accounting.label.accountclosuredate": "账户关闭日期",
    "accounting.label.comments": "评论",
    "accounting.label.entity": "实体",
    "accounting.label.closuredate": "关闭日期",
    "accounting.label.closedby": "关闭人",
    "accounting.label.updatedby": "更新人",
    "accounting.label.updatedon": "更新时间",
    "accounting.label.viewclosure": "查看关闭",
    "accounting.label.closurecreationdate": "关闭创建日期",
    "accounting.label.closingdate": "结账日期",
    "accounting.label.createclosure": "创建关闭",
    "accounting.label.closeaccountcreatedby": "关闭账户创建人",
    "accounting.label.frequentpostings": "常用发布",
    "accounting.label.debit": "借方",
    "accounting.label.credit": "贷方",
    "accounting.label.currency": "货币",
    "accounting.label.showpaymentdetails": "显示付款详情",
    "accounting.label.paymenttype": "付款类型",
    "accounting.label.cheque": "支票",
    "accounting.label.routingcode": "路由代码",
    "accounting.label.receipt": "收据",
    "accounting.label.bank": "银行",
    "accounting.label.comment": "评论",
    "accounting.label.transactiondate": "交易日期",
    "accounting.label.referencenumber": "参考号码",
    "accounting.label.addjournalentries": "添加会计分录",
    "accounting.label.amount": "金额",
    "accounting.label.financialactivitymapping": "财务活动映射",
    "accounting.label.definenewmapping": "定义新映射",
    "accounting.label.addfinancialactivitymapping": "添加财务活动映射",
    "accounting.label.editfinancialactivitymapping": "编辑财务活动映射",
    "accounting.label.viewfinancialactivitymapping": "查看财务活动映射",
    "accounting.label.financialactivity": "财务活动",
    "accounting.label.office": "办公室",
    "accounting.label.filter": "筛选",
    "accounting.label.fromdate": "开始日期",
    "accounting.label.todate": "结束日期",
    "accounting.label.transactionid": "交易 ID",
    "accounting.label.search": "搜索",
    "accounting.label.entryid": "条目 ID",
    "accounting.label.type": "类型",
    "accounting.label.clearall": "清除所有",
    "accounting.label.createdby": "创建者",
    "accounting.label.dateofopeningbalances": "开盘余额日期",
    "accounting.label.openingbalancescontra": "开盘余额对方账户",
    "accounting.label.openingbalances": "开盘余额",
    "accounting.label.save": "保存",
    "accounting.label.viewtransaction": "查看交易",
    "accounting.label.createdon": "创建于",
    "accounting.label.editclosure": "编辑结算",
  },

  hi: {
    "accounting.label.ThisTransactionIsReversed": "यह लेन-देन उलट दिया गया है",
    "accounting.label.FixedAmount": "निश्चित राशि",
"accounting.label.Accounts": "खाते",
    "accounting.label.chartofaccounts": "खातों की तालिका",
    "accounting.label.createaccount": "खाता बनाएं",
    "accounting.label.account": "खाता",
    "accounting.label.glcode": "जीएल कोड",
    "accounting.label.accounttype": "खाते का प्रकार",
    "accounting.label.disabled": "अक्षम",
    "accounting.label.manualentriesallowed": "मैन्युअल प्रविष्टियाँ अनुमत",
    "accounting.label.usedas": "के रूप में उपयोग किया गया",
    "accounting.label.createglaccount": "जीएल खाता बनाएं",
    "accounting.label.parent": "मूल खाता",
    "accounting.label.accountname": "खाते का नाम",
    "accounting.label.accountusage": "खाते का उपयोग",
    "accounting.label.tag": "टैग",
    "accounting.label.description": "विवरण",
    "accounting.label.viewglaccount": "जीएल खाता देखें",
    "accounting.label.editglaccount": "जीएल खाता संपादित करें",
    "accounting.label.submit": "प्रस्तुत करें",
    "accounting.label.update": "अद्यतन",
    "accounting.label.cancel": "रद्द करें",
    "accounting.label.disable": "अक्षम करें",
    "accounting.label.enable": "सक्षम करें",
    "accounting.label.name": "नाम",
    "accounting.label.action": "क्रिया",
    "accounting.label.editrule": "नियम संपादित करें",
    "accounting.label.viewrule": "नियम देखें",
    "accounting.label.debitaccountdetails": "डेबिट खाता विवरण",
    "accounting.label.creditaccountdetails": "क्रेडिट खाता विवरण",
    "accounting.label.accountingrulename": "लेखांकन नियम का नाम",
    "accounting.label.affectedglentries": "प्रभावित GL प्रविष्टियाँ",
    "accounting.label.createrule": "नियम बनाएँ",
    "accounting.label.accountingrules": "लेखांकन नियम",
    "accounting.label.debitaccount": "डेबिट खाता",
    "accounting.label.creditaccount": "क्रेडिट खाता",
    "accounting.label.debittags": "डेबिट टैग",
    "accounting.label.credittags": "क्रेडिट टैग",
    "accounting.label.entityname": "इकाई का नाम",
    "accounting.label.allowmultipledebitentries":
      "कई डेबिट प्रविष्टियों की अनुमति दें",
    "accounting.label.allowmultiplecreditentries":
      "कई क्रेडिट प्रविष्टियों की अनुमति दें",
    "accounting.label.subledgeraccount": "उप-खाता खाता",
    "accounting.label.closingentries": "समापन प्रविष्टियाँ",
    "accounting.label.accountclosuredate": "खाता समापन तिथि",
    "accounting.label.comments": "टिप्पणियाँ",
    "accounting.label.entity": "इकाई",
    "accounting.label.closuredate": "समापन तिथि",
    "accounting.label.closedby": "बंद किया गया द्वारा",
    "accounting.label.updatedby": "अद्यतन किया गया द्वारा",
    "accounting.label.updatedon": "अद्यतन तिथि",
    "accounting.label.viewclosure": "समापन देखें",
    "accounting.label.closurecreationdate": "समापन सृजन तिथि",
    "accounting.label.closingdate": "समापन तिथि",
    "accounting.label.createclosure": "समापन बनाएं",
    "accounting.label.closeaccountcreatedby": "समापन खाता सृजित द्वारा",
    "accounting.label.frequentpostings": "अक्सर की जाने वाली प्रविष्टियाँ",
    "accounting.label.debit": "डेबिट",
    "accounting.label.credit": "क्रेडिट",
    "accounting.label.currency": "मुद्रा",
    "accounting.label.showpaymentdetails": "भुगतान विवरण दिखाएं",
    "accounting.label.paymenttype": "भुगतान प्रकार",
    "accounting.label.cheque": "चेक",
    "accounting.label.routingcode": "रूटिंग कोड",
    "accounting.label.receipt": "रसीद",
    "accounting.label.bank": "बैंक",
    "accounting.label.comment": "टिप्पणी",
    "accounting.label.transactiondate": "लेनदेन की तारीख",
    "accounting.label.referencenumber": "संदर्भ संख्या",
    "accounting.label.addjournalentries": "लेख प्रविष्टियाँ जोड़ें",
    "accounting.label.amount": "राशि",
    "accounting.label.financialactivitymapping": "वित्तीय गतिविधि मानचित्रण",
    "accounting.label.definenewmapping": "नया मानचित्रण परिभाषित करें",
    "accounting.label.addfinancialactivitymapping":
      "वित्तीय गतिविधि मानचित्रण जोड़ें",
    "accounting.label.editfinancialactivitymapping":
      "वित्तीय गतिविधि मानचित्रण संपादित करें",
    "accounting.label.viewfinancialactivitymapping":
      "वित्तीय गतिविधि मानचित्रण देखें",
    "accounting.label.financialactivity": "वित्तीय गतिविधि",
    "accounting.label.office": "कार्यालय",
    "accounting.label.filter": "फ़िल्टर",
    "accounting.label.fromdate": "प्रारंभ तिथि",
    "accounting.label.todate": "समाप्ति तिथि",
    "accounting.label.transactionid": "लेनदेन आईडी",
    "accounting.label.search": "खोजें",
    "accounting.label.entryid": "प्रविष्टि आईडी",
    "accounting.label.type": "प्रकार",
    "accounting.label.clearall": "सभी साफ़ करें",
    "accounting.label.createdby": "द्वारा निर्मित",
    "accounting.label.dateofopeningbalances":
      "खातों की प्रारंभिक बैलेंस की तिथि",
    "accounting.label.openingbalancescontra": "प्रारंभिक बैलेंस का विरोधी खाता",
    "accounting.label.openingbalances": "प्रारंभिक बैलेंस",
    "accounting.label.save": "सहेजें",
    "accounting.label.viewtransaction": "लेनदेन देखें",
    "accounting.label.createdon": "पर बनाया गया",
    "accounting.label.editclosure": "समापन संपादित करें",
  },

  ka: {
    "accounting.label.ThisTransactionIsReversed": "ეს ტრანზაქცია გაუქმებულია",
    "accounting.label.FixedAmount": "ფიქსირებული თანხა",
"accounting.label.Accounts": "ანგარიშები",
    "accounting.label.chartofaccounts": "ანგარიშების ცხრილი",
    "accounting.label.createaccount": "ანგარიშის შექმნა",
    "accounting.label.account": "ანგარიში",
    "accounting.label.glcode": "GL კოდი",
    "accounting.label.accounttype": "ანგარიშის ტიპი",
    "accounting.label.disabled": "გამორთული",
    "accounting.label.manualentriesallowed": "ხელით შეყვანა ნებადართულია",
    "accounting.label.usedas": "გამოიყენება როგორც",
    "accounting.label.createglaccount": "GL ანგარიშის შექმნა",
    "accounting.label.parent": "მშობელი",
    "accounting.label.accountname": "ანგარიშის სახელი",
    "accounting.label.accountusage": "ანგარიშის გამოყენება",
    "accounting.label.tag": "ტეგი",
    "accounting.label.description": "აღწერა",
    "accounting.label.viewglaccount": "ნახე GL ანგარიში",
    "accounting.label.editglaccount": "GL ანგარიშის რედაქტირება",
    "accounting.label.submit": "გაგზავნა",
    "accounting.label.update": "განახლება",
    "accounting.label.cancel": "გაუქმება",
    "accounting.label.disable": "გამორთვა",
    "accounting.label.enable": "ჩართვა",
    "accounting.label.name": "სახელი",
    "accounting.label.action": "ქმედება",
    "accounting.label.editrule": "წესის რედაქტირება",
    "accounting.label.viewrule": "წესის ნახვა",
    "accounting.label.debitaccountdetails": "დებეტის ანგარიშის დეტალები",
    "accounting.label.creditaccountdetails": "კრედიტის ანგარიშის დეტალები",
    "accounting.label.accountingrulename": "ბუღალტრული წესის სახელი",
    "accounting.label.affectedglentries": "გავლენიანი GL ჩანაწერები",
    "accounting.label.createrule": "წესის შექმნა",
    "accounting.label.accountingrules": "ბუღალტრული წესები",
    "accounting.label.debitaccount": "დებეტის ანგარიში",
    "accounting.label.creditaccount": "კრედიტის ანგარიში",
    "accounting.label.debittags": "დებეტის ნიშნები",
    "accounting.label.credittags": "კრედიტის ნიშნები",
    "accounting.label.entityname": "ერთეულის სახელი",
    "accounting.label.allowmultipledebitentries":
      "მრავალი დებეტის ჩანაწერის ნებართვა",
    "accounting.label.allowmultiplecreditentries":
      "მრავალი კრედიტის ჩანაწერის ნებართვა",
    "accounting.label.subledgeraccount": "ქვე-ანგარიში",
    "accounting.label.closingentries": "დასკვნითი ჩანაწერები",
    "accounting.label.accountclosuredate": "ანგარიშის დახურვის თარიღი",
    "accounting.label.comments": "კომენტარები",
    "accounting.label.entity": "სუბიექტი",
    "accounting.label.closuredate": "დახურვის თარიღი",
    "accounting.label.closedby": "დახურა",
    "accounting.label.updatedby": "განახლებულია",
    "accounting.label.updatedon": "განახლების თარიღი",
    "accounting.label.viewclosure": "დახურვის ნახვა",
    "accounting.label.closurecreationdate": "დახურვის შექმნის თარიღი",
    "accounting.label.closingdate": "დახურვის თარიღი",
    "accounting.label.createclosure": "დახურვის შექმნა",
    "accounting.label.closeaccountcreatedby": "დახურვის ანგარიში შექმნილია",
    "accounting.label.frequentpostings": "ხშირი ჩანაწერები",
    "accounting.label.debit": "დებეტი",
    "accounting.label.credit": "კრედიტი",
    "accounting.label.currency": "ვალუტა",
    "accounting.label.showpaymentdetails": "გადახდის დეტალების ჩვენება",
    "accounting.label.paymenttype": "გადახდის ტიპი",
    "accounting.label.cheque": "ჩეკი",
    "accounting.label.routingcode": "მიმართულების კოდი",
    "accounting.label.receipt": "კვიტანი",
    "accounting.label.bank": "ბანკი",
    "accounting.label.comment": "კომენტარი",
    "accounting.label.transactiondate": "ტრანზაქციის თარიღი",
    "accounting.label.referencenumber": "ცნობის ნომერი",
    "accounting.label.addjournalentries": "ჟურნალის ჩანაწერების დამატება",
    "accounting.label.amount": "თანხა",
    "accounting.label.financialactivitymapping": "ფინანსური აქტივობის რუკა",
    "accounting.label.definenewmapping": "ახალი რუკის განსაზღვრა",
    "accounting.label.addfinancialactivitymapping":
      "ფინანსური აქტივობის რუკის დამატება",
    "accounting.label.editfinancialactivitymapping":
      "ფინანსური აქტივობის რუკის რედაქტირება",
    "accounting.label.viewfinancialactivitymapping":
      "ფინანსური აქტივობის რუკის ნახვა",
    "accounting.label.financialactivity": "ფინანსური აქტივობა",
    "accounting.label.office": "ოფისი",
    "accounting.label.filter": "ფილტრი",
    "accounting.label.fromdate": "დაწყების თარიღი",
    "accounting.label.todate": "დასრულების თარიღი",
    "accounting.label.transactionid": "ტრანზაქციის ID",
    "accounting.label.search": "ძიება",
    "accounting.label.entryid": "შესვლის ID",
    "accounting.label.type": "ტიპი",
    "accounting.label.clearall": "ყველას გასუფთავება",
    "accounting.label.createdby": "შექმნილია",
    "accounting.label.dateofopeningbalances": "ತೆರೆಯುವ ಶಿಷ್ಟಾಂಶಗಳ ದಿನಾಂಕ",
    "accounting.label.openingbalancescontra": "ಶಿಷ್ಟಾಂಶದ ಪ್ರತಿಕ್ರಿಯೆ ಖಾತೆ",
    "accounting.label.openingbalances": "ತೆರೆಯುವ ಶಿಷ್ಟಾಂಶಗಳು",
    "accounting.label.save": "ಉಳಿಸಿ",
    "accounting.label.viewtransaction": "ტრანზაქციის ნახვა",
    "accounting.label.createdon": "შეიქმნა",
    "accounting.label.editclosure": "დახურვის რედაქტირება",
  },

  lo: {
    "accounting.label.ThisTransactionIsReversed": "ລາຍການນີ້ໄດ້ຖືກກັບຄືນ",
    "accounting.label.FixedAmount": "ຈໍານວນຄົງທີ່",
"accounting.label.Accounts": "ບັນຊີ",
    "accounting.label.chartofaccounts": "ຕາຕະລາງບັນຊີ",
    "accounting.label.createaccount": "ສ້າງບັນຊີ",
    "accounting.label.account": "ບັນຊີ",
    "accounting.label.glcode": "GL ລະຫັດ",
    "accounting.label.accounttype": "ປະເພດບັນຊີ",
    "accounting.label.disabled": "ປິດໃຊ້ງານ",
    "accounting.label.manualentriesallowed": "ອະນຸຍາດໃຫ້ປ້ອນມື",
    "accounting.label.usedas": "ໃຊ້ເປັນ",
    "accounting.label.createglaccount": "ສ້າງບັນຊີ GL",
    "accounting.label.parent": "ບັນຊີຫຼັກ",
    "accounting.label.accountname": "ຊື່ບັນຊີ",
    "accounting.label.accountusage": "ການໃຊ້ບັນຊີ",
    "accounting.label.tag": "ແທັກ",
    "accounting.label.description": "ຄໍາອະທິບາຍ",
    "accounting.label.viewglaccount": "ເບິ່ງບັນຊີ GL",
    "accounting.label.editglaccount": "ແກ້ໄຂບັນຊີ GL",
    "accounting.label.submit": "ສົ່ງ",
    "accounting.label.update": "ອັບເດດ",
    "accounting.label.cancel": "ຍົກເລີກ",
    "accounting.label.disable": "ປິດໃຊ້ງານ",
    "accounting.label.enable": "ເປີດໃຊ້ງານ",
    "accounting.label.name": "ຊື່",
    "accounting.label.action": "ການກະທຳ",
    "accounting.label.editrule": "ແກ້ໄຂກົດ",
    "accounting.label.viewrule": "ເບິ່ງກົດ",
    "accounting.label.debitaccountdetails": "ລາຍລະອຽດບັນຊີເດບິດ",
    "accounting.label.creditaccountdetails": "ລາຍລະອຽດບັນຊີເຄຣດິດ",
    "accounting.label.accountingrulename": "ຊື່ກົດບັນຊີ",
    "accounting.label.affectedglentries": "ລາຍການ GL ທີ່ໄດ້ຮັບຜົນກະທົບ",
    "accounting.label.createrule": "ສ້າງກົດ",
    "accounting.label.accountingrules": "ກົດບັນຊີ",
    "accounting.label.debitaccount": "ບັນຊີເດບິດ",
    "accounting.label.creditaccount": "ບັນຊີເຄຣດິດ",
    "accounting.label.debittags": "ແທັກເດບິດ",
    "accounting.label.credittags": "ແທັກເຄຣດິດ",
    "accounting.label.entityname": "ຊື່ຫົວໜ່ວຍ",
    "accounting.label.allowmultipledebitentries": "ອະນຸຍາດໃຫ້ມີລາຍການເດບິດຫຼາຍ",
    "accounting.label.allowmultiplecreditentries":
      "ອະນຸຍາດໃຫ້ມີລາຍການເຄຣດິດຫຼາຍ",
    "accounting.label.subledgeraccount": "ບັນຊີຍ່ອຍ",
    "accounting.label.closingentries": "ລາຍການປິດບັນຊີ",
    "accounting.label.accountclosuredate": "ວັນທີປິດບັນຊີ",
    "accounting.label.comments": "ຄໍາເຫັນ",
    "accounting.label.entity": "ບໍລິສັດ",
    "accounting.label.closuredate": "ວັນທີປິດ",
    "accounting.label.closedby": "ປິດໂດຍ",
    "accounting.label.updatedby": "ປັບປຸງໂດຍ",
    "accounting.label.updatedon": "ວັນທີປັບປຸງ",
    "accounting.label.viewclosure": "ເບິ່ງການປິດ",
    "accounting.label.closurecreationdate": "ວັນທີສ້າງການປິດ",
    "accounting.label.closingdate": "ວັນທີປິດ",
    "accounting.label.createclosure": "ສ້າງການປິດ",
    "accounting.label.closeaccountcreatedby": "ບັນຊີປິດສ້າງໂດຍ",
    "accounting.label.frequentpostings": "ໂພສທີ່ໃຊ້ບ່ອຍ",
    "accounting.label.debit": "ເດບິດ",
    "accounting.label.credit": "ເຄຣດິດ",
    "accounting.label.currency": "ເງິນຕາ",
    "accounting.label.showpaymentdetails": "ສະແດງລາຍລະອຽດການຈ່າຍເງິນ",
    "accounting.label.paymenttype": "ປະເພດການຈ່າຍເງິນ",
    "accounting.label.cheque": "ເຊັກ",
    "accounting.label.routingcode": "ລະຫັດການນຳສົ່ງ",
    "accounting.label.receipt": "ໃບຮັບເງິນ",
    "accounting.label.bank": "ທະນາຄານ",
    "accounting.label.comment": "ຄຳເຫັນ",
    "accounting.label.transactiondate": "ວັນທີທຳອິດ",
    "accounting.label.referencenumber": "ໝາຍເລກອ້າງອີງ",
    "accounting.label.addjournalentries": "ເພີ່ມລາຍການບັນຊີ",
    "accounting.label.amount": "ຈໍານວນເງິນ",
    "accounting.label.financialactivitymapping": "ການແຜນທີ່ກິດຈະການການເງິນ",
    "accounting.label.definenewmapping": "ກຳນົດແຜນທີ່ໃໝ່",
    "accounting.label.addfinancialactivitymapping":
      "ເພີ່ມການແຜນທີ່ກິດຈະການການເງິນ",
    "accounting.label.editfinancialactivitymapping":
      "ແກ້ໄຂການແຜນທີ່ກິດຈະການການເງິນ",
    "accounting.label.viewfinancialactivitymapping":
      "ເບິ່ງການແຜນທີ່ກິດຈະການການເງິນ",
    "accounting.label.financialactivity": "ກິດຈະການການເງິນ",
    "accounting.label.office": "ສຳນັກງານ",
    "accounting.label.filter": "ການກອງ",
    "accounting.label.fromdate": "ວັນເລີ່ມຕົ້ນ",
    "accounting.label.todate": "ວັນສິ້ນສຸດ",
    "accounting.label.transactionid": "ID ການເຮັດທຸລະກໍາ",
    "accounting.label.search": "ຊອກຫາ",
    "accounting.label.entryid": "ID ລາຍການ",
    "accounting.label.type": "ປະເພດ",
    "accounting.label.clearall": "ລ້າງທັງໝົດ",
    "accounting.label.createdby": "ສ້າງໂດຍ",
    "accounting.label.dateofopeningbalances": "Atidarymo balansų data",
    "accounting.label.openingbalancescontra":
      "Atidarymo balansų priešpriešinis sąskaita",
    "accounting.label.openingbalances": "Atidarymo balansai",
    "accounting.label.save": "Išsaugoti",
    "accounting.label.viewtransaction": "ເບິ່ງທຸລະກໍາ",
    "accounting.label.createdon": "ສ້າງໃນ",
    "accounting.label.editclosure": "ແກ້ໄຂການປິດ",
  },

  my_MM: {
    "accounting.label.ThisTransactionIsReversed": "ဤငွေလွှဲမှုကို ပြန်လည်ဖျက်သိမ်းလိုက်ပါသည်",
    "accounting.label.FixedAmount": "သတ်မှတ်ငွေပမာဏ",
"accounting.label.Accounts": "အကောင့်များ",
    "accounting.label.chartofaccounts": "အကောင့်ဇယား",
    "accounting.label.createaccount": "အကောင့်ဖွင့်မည်",
    "accounting.label.account": "အကောင့်",
    "accounting.label.glcode": "GL ကုဒ်",
    "accounting.label.accounttype": "အကောင့်အမျိုးအစား",
    "accounting.label.disabled": "ပိတ်ထားသည်",
    "accounting.label.manualentriesallowed": "လက်ဖြင့်ထည့်သွင်းခွင့်ပြုသည်",
    "accounting.label.usedas": "အဖြစ်အသုံးပြုသည်",
    "accounting.label.createglaccount": "GL အကောင့်ဖွင့်မည်",
    "accounting.label.parent": "မိဘ",
    "accounting.label.accountname": "အကောင့်အမည်",
    "accounting.label.accountusage": "အကောင့်အသုံးပြုမှု",
    "accounting.label.tag": "တံဆိပ်",
    "accounting.label.description": "ဖော်ပြချက်",
    "accounting.label.viewglaccount": "GL အကောင့်ကြည့်မည်",
    "accounting.label.editglaccount": "GL အကောင့်တည်းဖြတ်မည်",
    "accounting.label.submit": "တင်ပြမည်",
    "accounting.label.update": "အပ်ဒိတ်",
    "accounting.label.cancel": "ပယ်ဖျက်မည်",
    "accounting.label.disable": "ပိတ်မည်",
    "accounting.label.enable": "ဖွင့်မည်",
    "accounting.label.name": "နာမည်",
    "accounting.label.action": "လုပ်ဆောင်ချက်",
    "accounting.label.editrule": "စည်းမျဉ်းပြင်ဆင်ရန်",
    "accounting.label.viewrule": "စည်းမျဉ်းကြည့်ရန်",
    "accounting.label.debitaccountdetails": "ဒေဘစ်အကောင့်အသေးစိတ်",
    "accounting.label.creditaccountdetails": "အကြွေးအကောင့်အသေးစိတ်",
    "accounting.label.accountingrulename": "စာရင်းကိုင် စည်းမျဉ်းနာမည်",
    "accounting.label.affectedglentries": "သက်ရောက်သော GL အချက်များ",
    "accounting.label.createrule": "စည်းမျဉ်း ဖန်တီးရန်",
    "accounting.label.accountingrules": "စာရင်းကိုင် စည်းမျဉ်းများ",
    "accounting.label.debitaccount": "ဒေဘစ်အကောင့်",
    "accounting.label.creditaccount": "အကြွေးအကောင့်",
    "accounting.label.debittags": "ဒေဘစ်အမှတ်အသားများ",
    "accounting.label.credittags": "အကြွေးအမှတ်အသားများ",
    "accounting.label.entityname": "အဖွဲ့အစည်းနာမည်",
    "accounting.label.allowmultipledebitentries":
      "ဒေဘစ် အချက်များများပြားစွာ ထည့်သွင်းရန် ခွင့်ပြုပါ",
    "accounting.label.allowmultiplecreditentries":
      "အကြွေး အချက်များများပြားစွာ ထည့်သွင်းရန် ခွင့်ပြုပါ",
    "accounting.label.subledgeraccount": "အနည်းငယ်စာရင်းစစ် အကောင့်",
    "accounting.label.closingentries": "ပိတ်ခြင်း အဝင်စာရင်းများ",
    "accounting.label.accountclosuredate": "အကောင့်ပိတ်သိမ်းသည့်နေ့",
    "accounting.label.comments": "မှတ်ချက်များ",
    "accounting.label.entity": "အဖွဲ့အစည်း",
    "accounting.label.closuredate": "ပိတ်သိမ်းသည့်နေ့",
    "accounting.label.closedby": "ပိတ်သိမ်းသူ",
    "accounting.label.updatedby": "ပြင်ဆင်သူ",
    "accounting.label.updatedon": "ပြင်ဆင်သည့်နေ့",
    "accounting.label.viewclosure": "ပိတ်သိမ်းမှုကြည့်ရန်",
    "accounting.label.closurecreationdate": "ပိတ်သိမ်းမှု ဖန်တီးသည့်နေ့",
    "accounting.label.closingdate": "ပိတ်သိမ်းရက်",
    "accounting.label.createclosure": "ပိတ်သိမ်းမှု ဖန်တီးရန်",
    "accounting.label.closeaccountcreatedby": "ပိတ်သိမ်းအကောင့် ဖန်တီးသူ",
    "accounting.label.frequentpostings": "မကြာခဏဖော်ပြသောအချက်အလက်များ",
    "accounting.label.debit": "ဒက်ဘစ်",
    "accounting.label.credit": "ခရက်ဒစ်",
    "accounting.label.currency": "ငွေကြေး",
    "accounting.label.showpaymentdetails": "ငွေပေးချေမှုအသေးစိတ်များကိုပြပါ",
    "accounting.label.paymenttype": "ငွေပေးချေမှုအမျိုးအစား",
    "accounting.label.cheque": "ချက်",
    "accounting.label.routingcode": "လမ်းကြောင်းကုဒ်",
    "accounting.label.receipt": "လက်ခံရရှိကြောင်းဗောက်ချာ",
    "accounting.label.bank": "ဘဏ်",
    "accounting.label.comment": "မှတ်ချက်",
    "accounting.label.transactiondate": "ငွေလွှဲပြောင်းသည့်ရက်စွဲ",
    "accounting.label.referencenumber": "ကိုးကားနံပါတ်",
    "accounting.label.addjournalentries": "စာရင်းသွင်းမှုများထည့်မည်",
    "accounting.label.amount": "ငွေပမာဏ",
    "accounting.label.financialactivitymapping":
      "ဘဏ္ဍာရေး လှမ်းမြောက်မှု မြေပုံဆွဲခြင်း",
    "accounting.label.definenewmapping": "မြေပုံဆွဲခြင်း အသစ် သတ်မှတ်ပါ",
    "accounting.label.addfinancialactivitymapping":
      "ဘဏ္ဍာရေး လှမ်းမြောက်မှု မြေပုံဆွဲခြင်း ထည့်သွင်းပါ",
    "accounting.label.editfinancialactivitymapping":
      "ဘဏ္ဍာရေး လှမ်းမြောက်မှု မြေပုံဆွဲခြင်း ပြင်ဆင်ပါ",
    "accounting.label.viewfinancialactivitymapping":
      "ဘဏ္ဍာရေး လှမ်းမြောက်မှု မြေပုံဆွဲခြင်း ကြည့်ရှုပါ",
    "accounting.label.financialactivity": "ဘဏ္ဍာရေး လှမ်းမြောက်မှု",
    "accounting.label.office": "ရုံး",
    "accounting.label.filter": "ဖလ်ထာ",
    "accounting.label.fromdate": "စတင်သည့်ရက်စွဲ",
    "accounting.label.todate": "ပြီးဆုံးသည့်ရက်စွဲ",
    "accounting.label.transactionid": "ငွေလွှဲချက် ID",
    "accounting.label.search": "ရှာဖွေပါ",
    "accounting.label.entryid": "အဝင် ID",
    "accounting.label.type": "အမျိုးအစား",
    "accounting.label.clearall": "အားလုံးရှင်းလင်းပါ",
    "accounting.label.createdby": "ဖန်တီးသူ",
    "accounting.label.dateofopeningbalances": "ဖွင့်စနစ် ငွေပမာဏ ရက်စွဲ",
    "accounting.label.openingbalancescontra":
      "ဖွင့်စနစ် ငွေပမာဏ အပြန်အလှန်အကောင့်",
    "accounting.label.openingbalances": "ဖွင့်စနစ် ငွေပမာဏ",
    "accounting.label.save": "သိမ်းဆည်းပါ",
    "accounting.label.viewtransaction": "ငွေလွှဲကြည့်ရန်",
    "accounting.label.createdon": "ဖန်တီးသည့်နေ့",
    "accounting.label.editclosure": "ပိတ်ချိန်တည်းဖြတ်ရန်",
  },

  my: {
    "accounting.label.ThisTransactionIsReversed": "ဤငွေလွှဲမှုကို ပြန်လည်ဖျက်သိမ်းလိုက်ပါသည်",
    "accounting.label.FixedAmount": "သတ်မှတ်ငွေပမာဏ",
"accounting.label.Accounts": "အကောင့်များ",
    "accounting.label.chartofaccounts": "အကောင့်ဇယား",
    "accounting.label.createaccount": "အကောင့်ဖွင့်မည်",
    "accounting.label.account": "အကောင့်",
    "accounting.label.glcode": "GL ကုဒ်",
    "accounting.label.accounttype": "အကောင့်အမျိုးအစား",
    "accounting.label.disabled": "ပိတ်ထားသည်",
    "accounting.label.manualentriesallowed": "လက်ဖြင့်ထည့်သွင်းခွင့်ပြုသည်",
    "accounting.label.usedas": "အဖြစ်အသုံးပြုသည်",
    "accounting.label.createglaccount": "GL အကောင့်ဖွင့်မည်",
    "accounting.label.parent": "မိဘ",
    "accounting.label.accountname": "အကောင့်အမည်",
    "accounting.label.accountusage": "အကောင့်အသုံးပြုမှု",
    "accounting.label.tag": "တံဆိပ်",
    "accounting.label.description": "ဖော်ပြချက်",
    "accounting.label.viewglaccount": "GL အကောင့်ကြည့်မည်",
    "accounting.label.editglaccount": "GL အကောင့်တည်းဖြတ်မည်",
    "accounting.label.submit": "တင်ပြမည်",
    "accounting.label.update": "အပ်ဒိတ်",
    "accounting.label.cancel": "ပယ်ဖျက်မည်",
    "accounting.label.disable": "ပိတ်မည်",
    "accounting.label.enable": "ဖွင့်မည်",
    "accounting.label.name": "နာမည်",
    "accounting.label.action": "လုပ်ဆောင်ချက်",
    "accounting.label.editrule": "စည်းမျဉ်း ပြင်ဆင်ရန်",
    "accounting.label.viewrule": "စည်းမျဉ်း ကြည့်ရန်",
    "accounting.label.debitaccountdetails": "ဒေဘစ် အကောင့် အသေးစိတ်",
    "accounting.label.creditaccountdetails": "အကြွေး အကောင့် အသေးစိတ်",
    "accounting.label.accountingrulename": "စာရင်းကိုင် စည်းမျဉ်း နာမည်",
    "accounting.label.affectedglentries": "သက်ရောက်သော GL အချက်များ",
    "accounting.label.createrule": "စည်းမျဉ်း ဖန်တီးရန်",
    "accounting.label.accountingrules": "စာရင်းကိုင် စည်းမျဉ်းများ",
    "accounting.label.debitaccount": "ဒေဘစ် အကောင့်",
    "accounting.label.creditaccount": "အကြွေး အကောင့်",
    "accounting.label.debittags": "ဒေဘစ် အမှတ်အသားများ",
    "accounting.label.credittags": "အကြွေး အမှတ်အသားများ",
    "accounting.label.entityname": "အဖွဲ့အစည်း နာမည်",
    "accounting.label.allowmultipledebitentries":
      "ဒေဘစ် အချက်များများပြားစွာ ထည့်သွင်းရန် ခွင့်ပြုပါ",
    "accounting.label.allowmultiplecreditentries":
      "အကြွေး အချက်များများပြားစွာ ထည့်သွင်းရန် ခွင့်ပြုပါ",
    "accounting.label.subledgeraccount": "အနည်းငယ် စာရင်းစစ် အကောင့်",
    "accounting.label.closingentries": "ပိတ်သိမ်းစာရင်းများ",
    "accounting.label.accountclosuredate": "အကောင့်ပိတ်သိမ်းရက်စွဲ",
    "accounting.label.comments": "မှတ်ချက်များ",
    "accounting.label.entity": "အဖွဲ့အစည်း",
    "accounting.label.closuredate": "ပိတ်သိမ်းရက်စွဲ",
    "accounting.label.closedby": "ပိတ်သိမ်းသူ",
    "accounting.label.updatedby": "ပြင်ဆင်သူ",
    "accounting.label.updatedon": "ပြင်ဆင်ချိန်",
    "accounting.label.viewclosure": "ပိတ်သိမ်းချက်ကြည့်ရန်",
    "accounting.label.closurecreationdate": "ပိတ်သိမ်းဖန်တီးချိန်",
    "accounting.label.closingdate": "ပိတ်သိမ်းရက်",
    "accounting.label.createclosure": "ပိတ်သိမ်းဖန်တီးရန်",
    "accounting.label.closeaccountcreatedby": "ပိတ်သိမ်းအကောင့် ဖန်တီးသူ",
    "accounting.label.frequentpostings": "မကြာခဏတင်သွင်းမှုများ",
    "accounting.label.debit": "ဒက်ဘစ်",
    "accounting.label.credit": "ခရက်ဒစ်",
    "accounting.label.currency": "ငွေကြေး",
    "accounting.label.showpaymentdetails": "ငွေပေးချေမှုအသေးစိတ်များပြရန်",
    "accounting.label.paymenttype": "ငွေပေးချေမှုအမျိုးအစား",
    "accounting.label.cheque": "ချက်",
    "accounting.label.routingcode": "လမ်းကြောင်းကုဒ်",
    "accounting.label.receipt": "လက်ခံရရှိမှု",
    "accounting.label.bank": "ဘဏ်",
    "accounting.label.comment": "မှတ်ချက်",
    "accounting.label.transactiondate": "လက်တွေ့ရက်စွဲ",
    "accounting.label.referencenumber": "ကိုးကားနံပါတ်",
    "accounting.label.addjournalentries": "စာရင်းသွင်းမှုများထည့်မည်",
    "accounting.label.amount": "ငွေပမာဏ",
    "accounting.label.financialactivitymapping":
      "ဘဏ္ဍာရေး လှုပ်ရှားမှု မြေပုံဆွဲခြင်း",
    "accounting.label.definenewmapping": "မြေပုံဆွဲခြင်းအသစ် သတ်မှတ်ပါ",
    "accounting.label.addfinancialactivitymapping":
      "ဘဏ္ဍာရေး လှုပ်ရှားမှု မြေပုံဆွဲခြင်း ထည့်ပါ",
    "accounting.label.editfinancialactivitymapping":
      "ဘဏ္ဍာရေး လှုပ်ရှားမှု မြေပုံဆွဲခြင်း ပြင်ဆင်ပါ",
    "accounting.label.viewfinancialactivitymapping":
      "ဘဏ္ဍာရေး လှုပ်ရှားမှု မြေပုံဆွဲခြင်း ကြည့်ပါ",
    "accounting.label.financialactivity": "ဘဏ္ဍာရေး လှုပ်ရှားမှု",
    "accounting.label.office": "ရုံး",
    "accounting.label.filter": "စိစစ်ခြင်း",
    "accounting.label.fromdate": "စတင်ရက်",
    "accounting.label.todate": "ပြီးဆုံးရက်",
    "accounting.label.transactionid": "ငွေလွှဲစာရင်း ID",
    "accounting.label.search": "ရှာဖွေရန်",
    "accounting.label.entryid": "စာရင်း ID",
    "accounting.label.type": "အမျိုးအစား",
    "accounting.label.clearall": "အားလုံးရှင်းပါ",
    "accounting.label.createdby": "ဖန်တီးသူ",
    "accounting.label.dateofopeningbalances": "ဖွင့်ချိန် ငွေပမာဏရက်စွဲ",
    "accounting.label.openingbalancescontra":
      "ဖွင့်ချိန် ငွေပမာဏ အပြန်အလှန် အကောင့်",
    "accounting.label.openingbalances": "ဖွင့်ချိန် ငွေပမာဏ",
    "accounting.label.save": "သိမ်းဆည်းပါ",
    "accounting.label.viewtransaction": "ငွေလွှဲကြည့်ရန်",
    "accounting.label.createdon": "ဖန်တီးထားသည့်နေ့",
    "accounting.label.editclosure": "ပိတ်ခြင်းကိုပြင်ဆင်ရန်",
  },

  vi: {
    "accounting.label.ThisTransactionIsReversed": "Giao dịch này đã bị đảo ngược",
    "accounting.label.FixedAmount": "Số tiền cố định",
    "accounting.label.Accounts": "Tài khoản",
    "accounting.label.chartofaccounts": "Biểu mẫu tài khoản",
    "accounting.label.createaccount": "Tạo tài khoản",
    "accounting.label.account": "Tài khoản",
    "accounting.label.glcode": "Mã GL",
    "accounting.label.accounttype": "Loại tài khoản",
    "accounting.label.disabled": "Đã tắt",
    "accounting.label.manualentriesallowed": "Cho phép nhập thủ công",
    "accounting.label.usedas": "Sử dụng như",
    "accounting.label.createglaccount": "Tạo tài khoản GL",
    "accounting.label.parent": "Tài khoản cha",
    "accounting.label.accountname": "Tên tài khoản",
    "accounting.label.accountusage": "Sử dụng tài khoản",
    "accounting.label.tag": "Thẻ",
    "accounting.label.description": "Mô tả",
    "accounting.label.viewglaccount": "Xem tài khoản GL",
    "accounting.label.editglaccount": "Chỉnh sửa tài khoản GL",
    "accounting.label.submit": "Gửi",
    "accounting.label.update": "Cập nhật",
    "accounting.label.cancel": "Hủy",
    "accounting.label.disable": "Vô hiệu hóa",
    "accounting.label.enable": "Kích hoạt",
    "accounting.label.name": "Tên",
    "accounting.label.action": "Hành động",
    "accounting.label.editrule": "Chỉnh sửa quy tắc",
    "accounting.label.viewrule": "Xem quy tắc",
    "accounting.label.debitaccountdetails": "Chi tiết tài khoản ghi nợ",
    "accounting.label.creditaccountdetails": "Chi tiết tài khoản ghi có",
    "accounting.label.accountingrulename": "Tên quy tắc kế toán",
    "accounting.label.affectedglentries": "Mục GL bị ảnh hưởng",
    "accounting.label.createrule": "Tạo quy tắc",
    "accounting.label.accountingrules": "Quy tắc kế toán",
    "accounting.label.debitaccount": "Tài khoản ghi nợ",
    "accounting.label.creditaccount": "Tài khoản ghi có",
    "accounting.label.debittags": "Thẻ ghi nợ",
    "accounting.label.credittags": "Thẻ ghi có",
    "accounting.label.entityname": "Tên thực thể",
    "accounting.label.allowmultipledebitentries": "Cho phép nhiều mục ghi nợ",
    "accounting.label.allowmultiplecreditentries": "Cho phép nhiều mục ghi có",
    "accounting.label.subledgeraccount": "Tài khoản sổ phụ",
    "accounting.label.closingentries": "Bút Toán Kết Sổ",
    "accounting.label.accountclosuredate": "Ngày Kết Sổ Tài Khoản",
    "accounting.label.comments": "Nhận Xét",
    "accounting.label.entity": "Thực Thể",
    "accounting.label.closuredate": "Ngày Kết Sổ",
    "accounting.label.closedby": "Đóng Bởi",
    "accounting.label.updatedby": "Cập Nhật Bởi",
    "accounting.label.updatedon": "Cập Nhật Vào",
    "accounting.label.viewclosure": "Xem Kết Sổ",
    "accounting.label.closurecreationdate": "Ngày Tạo Kết Sổ",
    "accounting.label.closingdate": "Ngày Đóng",
    "accounting.label.createclosure": "Tạo Kết Sổ",
    "accounting.label.closeaccountcreatedby": "Tài Khoản Kết Sổ Tạo Bởi",
    "accounting.label.frequentpostings": "Bài đăng thường xuyên",
    "accounting.label.debit": "Nợ",
    "accounting.label.credit": "Có",
    "accounting.label.currency": "Tiền tệ",
    "accounting.label.showpaymentdetails": "Hiển thị chi tiết thanh toán",
    "accounting.label.paymenttype": "Loại thanh toán",
    "accounting.label.cheque": "Séc",
    "accounting.label.routingcode": "Mã định tuyến",
    "accounting.label.receipt": "Biên lai",
    "accounting.label.bank": "Ngân hàng",
    "accounting.label.comment": "Bình luận",
    "accounting.label.transactiondate": "Ngày giao dịch",
    "accounting.label.referencenumber": "Mã tham chiếu",
    "accounting.label.addjournalentries": "Thêm mục nhật ký",
    "accounting.label.amount": "Số tiền",
    "accounting.label.financialactivitymapping":
      "Lập bản đồ Hoạt động Tài chính",
    "accounting.label.definenewmapping": "Xác định Bản đồ Mới",
    "accounting.label.addfinancialactivitymapping":
      "Thêm Lập bản đồ Hoạt động Tài chính",
    "accounting.label.editfinancialactivitymapping":
      "Chỉnh sửa Lập bản đồ Hoạt động Tài chính",
    "accounting.label.viewfinancialactivitymapping":
      "Xem Lập bản đồ Hoạt động Tài chính",
    "accounting.label.financialactivity": "Hoạt động Tài chính",
    "accounting.label.office": "Văn phòng",
    "accounting.label.filter": "Bộ lọc",
    "accounting.label.fromdate": "Từ ngày",
    "accounting.label.todate": "Đến ngày",
    "accounting.label.transactionid": "Mã giao dịch",
    "accounting.label.search": "Tìm kiếm",
    "accounting.label.entryid": "Mã mục",
    "accounting.label.type": "Loại",
    "accounting.label.clearall": "Xóa tất cả",
    "accounting.label.createdby": "Được tạo bởi",
    "accounting.label.dateofopeningbalances": "Ngày mở số dư",
    "accounting.label.openingbalancescontra": "Tài khoản đối ứng mở số dư",
    "accounting.label.openingbalances": "Số dư mở",
    "accounting.label.save": "Lưu",
    "accounting.label.viewtransaction": "Xem giao dịch",
    "accounting.label.createdon": "Được tạo vào",
    "accounting.label.editclosure": "Chỉnh sửa đóng",
  },
};
